@if (currentOf() && articleInfos()) {
  @if (this.simpleWithDate()) {

    <div
      class="flex-container-row align-center">
      <div class="flex-container">
        <div class="flex-row gap-12">
          <div class="flex-col">
            <div class="caption secondary">{{ currentOf()?.numero }}&nbsp;</div>
            <div class="tiny on-background-alt">{{ currentOf().ligne.denomination }}&nbsp;</div>
            <div class="text-line">
              <span class="tiny">Du</span>
              <span
                class="tiny">{{ currentOf().dateDebut ? (currentOf().dateDebut | date : 'dd/MM/yyyy') : '-' }}</span>
            </div>
            <div class="text-line">
              <span class="tiny">Au</span>
              <span
                class="tiny">{{ currentOf().dateFin ? (currentOf().dateFin | date : 'dd/MM/yyyy') : '-' }}</span>
            </div>
          </div>
          @if (actions()) {
            <div class="ml-auto flex-row h100 align-center">
              <button mat-icon-button (click)="go()" matTooltip="Voir l'OF">
                <mat-icon>link</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {

    <div
      class="flex-container-row align-center">
      <div class="flex-container">
        <div class="flex-row gap-12">
          <div class="flex-col">
            <div class="flex-row gap-8">
              <div class="caption on-background-alt">{{ currentOf().ligne.denomination }}&nbsp;</div>
              <div class="caption secondary">{{ currentOf()?.numero }}&nbsp;</div>
            </div>
            <div class="flex-row">
              <div class="caption">
                @if (articleInfos()?.bio) {
                  <vl-bio-logo/>
                } {{ articleInfos().denomination }}
              </div>
            </div>
          </div>
          @if (actions()) {
            <div class="ml-auto flex-row h100 align-center">
              <button mat-icon-button (click)="go()" matTooltip="Voir l'OF">
                <mat-icon>link</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }
}
